import { ComponentFactoryResolver } from '@angular/core';
import { ComponentRef } from '@angular/core';
import { Directive } from '@angular/core';
import { Input } from '@angular/core';
import { HostListener } from '@angular/core';
import { ViewContainerRef } from '@angular/core';
import { OnInit } from '@angular/core';

import { UITooltipComponent } from './tooltip.component';
import { UIStickPosition } from 'app/ui/core/position';

@Directive({ selector: '[uiTooltip]' })
export class UITooltipDirective implements OnInit {

    private _tooltipComponent: ComponentRef<UITooltipComponent>;

    @Input()
    uiTooltip: string;

    @Input()
    uiTooltipPosition: UIStickPosition;

    @Input()
    uiTooltipType: 'hover' | 'click' = 'hover';

    toggleInfo: boolean = false;

    constructor(private _viewContainerRef: ViewContainerRef, private _resolver: ComponentFactoryResolver) {

    }

    ngOnInit() {
        const factory = this._resolver.resolveComponentFactory(UITooltipComponent);
        this._tooltipComponent = this._viewContainerRef.createComponent(factory);
        this._tooltipComponent.instance.content = this.uiTooltip;
        this._tooltipComponent.instance.hostElement = this._viewContainerRef.element.nativeElement;
        this._tooltipComponent.instance.position = this.uiTooltipPosition || 'right';
    }

    @HostListener('focusin')
    @HostListener('mouseenter')
    show(): void {
        if (this.uiTooltipType === 'hover') {
          this._tooltipComponent.instance.content = this.uiTooltip;
          this._tooltipComponent.instance.show();
        }
    }

    @HostListener('focusout')
    @HostListener('mouseleave')
    hide(): void {
      if (this.uiTooltipType === 'hover') {
        this._tooltipComponent.instance.hide();
      }
    }

    @HostListener('click')
    toggle(): void {
      if (this.uiTooltipType === 'click') {
        if (!this.toggleInfo) {
          this.toggleInfo = true;
          this._tooltipComponent.instance.content = this.uiTooltip;
          this._tooltipComponent.instance.show();
        } else {
          this.toggleInfo = false;
          this._tooltipComponent.instance.hide();
        }
      }
    }

    @HostListener('document:click', ['$event.target'])
    onClick(targetElement) {
      const clickedInside = this._viewContainerRef.element.nativeElement.contains(targetElement);
      if (!clickedInside) {
        this.toggleInfo = false;
        this._tooltipComponent.instance.hide();
      }
    }

}
